// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__7Hzhz","selected":"Tabs_selected__HHQNB"};